import axios from 'axios'

export default () => {
	return axios.create({
		baseURL: (process.env.NODE_ENV !== 'production') ? 'http://localhost:3000' : 'http://138.68.170.51:3000', //TODO: change latter to domain
		headers: {
			'Content-Type': 'application/json',
			'Authorization': `Bearer ${localStorage.getItem('user-token')}`
		}
		/* headers.common['Authorization'] = AUTH_TOKEN;
		headers.post['Content-Type'] = 'application/x-www-form-urlencoded'; */

	});
}



// WEBPACK FOOTER //
// ./src/config/Api.js